<template>
  <el-upload
    :action="fullAction"
    :multiple="false"
    :show-file-list="showList"
    :file-list="fileList"
    :list-type="picture?'picture':'text'"
    :before-remove="beforeRemove"
    :on-remove="handleRemove"
    :on-progress="handleProgress"
    :on-success="handleSuccess"
    :on-error="handleError"
    class="myUpLoad"
  >
    <el-button icon="el-icon-upload" size="small" type="primary">{{text}}</el-button>
  </el-upload>
</template>
<style lang="scss">
.myUpLoad {
  .el-upload-list__item .el-icon-close-tip {
    opacity: 0;
  }
}
</style>
<script>
export default {
  name: "file-upload",
  data() {
    return {
      fullAction: "",
      fileList: [],
      loading: "",
      baseUrl: process.env.VUE_APP_DOWNLOAD_URL
    };
  },
  props: {
    action: String,
    text: {
      default: "点击上传"
    },
    picture: Boolean,
    showList: Boolean,
    value: {
      default: () => []
    }
  },
  watch: {
    value(val) {
      let arr = JSON.parse(JSON.stringify(val));
      this.fileList = arr.map(v => {
        v.url = this.baseUrl + v.url;
        return v;
      });
    }
  },
  methods: {
    beforeRemove(file /* , fileList */) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleRemove(file, fileList) {
      let _this = this;
      let arr = fileList.slice();
      arr.map(s => {
        s.url = s.url.replace(_this.baseUrl, "");
      });
      this.$emit("input", arr);
    },
    handleProgress() {
      this.loading = this.$loading({
        lock: true,
        text: "文件上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    handleSuccess(res, file, fileList) {
      let _this = this;
      _this.loading.close();
      if (res.success) {
        _this.$message({
          message: "上传成功",
          type: "success"
        });
      } else {
        _this.$message({
          message: res.msg || "上传失败",
          type: "error"
        });
        fileList.splice(fileList.length - 1, 1);
        return;
      }
      let arr = fileList.slice();
      let obj = {};
      obj.url = res.msg;
      obj.name = file.name;
      arr.splice(arr.indexOf(file), 1, obj);
      arr.map(s => {
        s.url = s.url.replace(_this.baseUrl, "");
      });
      this.$emit("input", arr);
    },
    handleError(/* err, file, fileList */) {
      this.loading.close();
      // fileList.splice(fileList.length - 1, 1);
      this.$message.error("上传失败");
    }
  },
  mounted() {
    this.fullAction = process.env.VUE_APP_BASE_URL + this.action;
    this.fileList = JSON.parse(JSON.stringify(this.value));
  }
};
</script>
